const currentHostname = () => (typeof window === 'undefined' ? '' : window.location.hostname)

const isZublimeHostname = (hostname = '') => {
  const normalizedHostname = hostname.trim().toLowerCase().split(':')[0].replace(/\.$/, '')
  return normalizedHostname === 'zublime.com' || normalizedHostname.endsWith('.zublime.com')
}

const platformUrl = (configuredUrl, hostname = currentHostname()) => {
  if (!configuredUrl || !isZublimeHostname(hostname)) return configuredUrl
  return configuredUrl.replace(/(^|[./])(?:outboundhq|familiohq)\.com(?=[:/]|$)/, '$1zublime.com')
}

const platformAppName = (configuredAppName, hostname = currentHostname()) =>
  isZublimeHostname(hostname) ? 'outbound' : configuredAppName

module.exports = { platformAppName, platformUrl }
